import { generateId } from '../../utils/vsmGeometry';
import type { Organization } from '../../types';

export function importRolesFromText(
  importText: string,
  organization: Organization
): { departments: Organization['departments']; roles: Organization['roles']; count: number } {
  const lines = importText.trim().split('\n').filter(l => l.trim());
  
  let updatedDepartments = [...organization.departments];
  const newRoles: any[] = [];
  
  lines.forEach(line => {
    const parts = line.split('\t').map(p => p.trim());
    if (parts.length >= 3) {
      const deptName = parts[0];
      const roleName = parts[1];
      const cost = parseFloat(parts[2]) || 0;
      const qty = parts[3] ? Math.max(1, parseInt(parts[3])) : 1;
      
      let dept = updatedDepartments.find(d => d.name.toLowerCase() === deptName.toLowerCase());
      if (!dept) {
        const newDeptId = generateId();
        dept = { 
          id: newDeptId, 
          name: deptName, 
          color: '#3b82f6', 
          totalHeadcount: 0,
          visible: true 
        };
        updatedDepartments = [...updatedDepartments, dept];
      }
      
      // Atualizar totalHeadcount
      updatedDepartments = updatedDepartments.map(d => 
        d.id === dept!.id 
          ? { ...d, totalHeadcount: (d.totalHeadcount || 0) + qty }
          : d
      );
      
      newRoles.push({
        id: generateId(),
        name: roleName,
        departmentId: dept.id,
        costPerHour: Math.max(0, cost),
        currency: 'BRL',
        quantity: qty,
        visible: true
      });
    }
  });
  
  return {
    departments: updatedDepartments,
    roles: [...organization.roles, ...newRoles],
    count: newRoles.length
  };
}
